/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { NodeCompat } from '../../compat/NodeCompat';
import { Document } from '../../core/models/Document';
import { Node } from '../../core/models/Node';
import { IDefinition } from '../../core/models/common/IDefinition';
import { IExample } from '../../core/models/common/IExample';
import { Operation } from '../../core/models/common/Operation';
import { Schema } from '../../core/models/common/Schema';
import { IVisitor } from '../../core/visitors/IVisitor';
import { Traverser } from '../../core/visitors/Traverser';
import { IOasPropertySchema } from '../models/IOasPropertySchema';
import { OasDocument } from '../models/OasDocument';
import { OasHeader } from '../models/OasHeader';
import { OasOperation } from '../models/OasOperation';
import { OasPathItem } from '../models/OasPathItem';
import { OasPaths } from '../models/OasPaths';
import { OasResponse } from '../models/OasResponse';
import { OasResponses } from '../models/OasResponses';
import { OasSchema } from '../models/OasSchema';
import { OasXML } from '../models/OasXML';

/**
 * Constructor.
 * @param {*} visitor
 * @class
 * @extends Traverser
 * @author eric.wittmann@gmail.com
 */
export class OasTraverser extends Traverser implements IOasVisitor {
    public constructor(visitor : IVisitor) {
        super(visitor);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.Traverser#traverseDocument(io.apicurio.datamodels.core.models.Document)
     * @param {Document} node
     */
    traverseDocument(node : Document) {
        let doc : OasDocument = <OasDocument>node;
        super.traverseDocument(node);
        this.traverseIfNotNull(doc.paths);
        this.traverseCollection(doc.security);
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitPaths(io.apicurio.datamodels.openapi.models.OasPaths)
     * @param {OasPaths} node
     */
    public visitPaths(node : OasPaths) {
        node.accept(this.visitor);
        this.traverseIndexedNode(node);
        this.traverseExtensions(node);
        this.traverseValidationProblems(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitPathItem(io.apicurio.datamodels.openapi.models.OasPathItem)
     * @param {OasPathItem} node
     */
    public visitPathItem(node : OasPathItem) {
        node.accept(this.visitor);
        this.traversePathItem(node);
        this.traverseExtensions(node);
        this.traverseValidationProblems(node);
    }

    /**
     * Traverses a path item.
     * @param {OasPathItem} node
     */
    traversePathItem(node : OasPathItem) {
        this.traverseIfNotNull(node.get);
        this.traverseIfNotNull(node.put);
        this.traverseIfNotNull(node.post);
        this.traverseIfNotNull(node.delete);
        this.traverseIfNotNull(node.options);
        this.traverseIfNotNull(node.head);
        this.traverseIfNotNull(node.patch);
        this.traverseCollection(node.parameters);
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitResponse(io.apicurio.datamodels.openapi.models.OasResponse)
     * @param {OasResponse} node
     */
    public visitResponse(node : OasResponse) {
        node.accept(this.visitor);
        this.traverseResponse(node);
        this.traverseExtensions(node);
        this.traverseValidationProblems(node);
    }

    traverseResponse(node : OasResponse) {
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitResponses(io.apicurio.datamodels.openapi.models.OasResponses)
     * @param {OasResponses} node
     */
    public visitResponses(node : OasResponses) {
        node.accept(this.visitor);
        this.traverseIndexedNode(node);
        this.traverseExtensions(node);
        this.traverseValidationProblems(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitXML(io.apicurio.datamodels.openapi.models.OasXML)
     * @param {OasXML} node
     */
    public visitXML(node : OasXML) {
        node.accept(this.visitor);
        this.traverseExtensions(node);
        this.traverseValidationProblems(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitAllOfSchema(io.apicurio.datamodels.openapi.models.OasSchema)
     * @param {OasSchema} node
     */
    public visitAllOfSchema(node : OasSchema) {
        this.visitSchema(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitItemsSchema(io.apicurio.datamodels.openapi.models.OasSchema)
     * @param {OasSchema} node
     */
    public visitItemsSchema(node : OasSchema) {
        this.visitSchema(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitAdditionalPropertiesSchema(io.apicurio.datamodels.openapi.models.OasSchema)
     * @param {OasSchema} node
     */
    public visitAdditionalPropertiesSchema(node : OasSchema) {
        this.visitSchema(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitPropertySchema(io.apicurio.datamodels.openapi.models.IOasPropertySchema)
     * @param {*} node
     */
    public visitPropertySchema(node : IOasPropertySchema) {
        this.visitSchema(<Schema><any>node);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.Traverser#traverseSchema(io.apicurio.datamodels.core.models.common.Schema)
     * @param {Schema} node
     */
    traverseSchema(node : Schema) {
        super.traverseSchema(node);
        let schema : OasSchema = <OasSchema>node;
        if(NodeCompat.isList(schema.items)) {
            this.traverseCollection(<Array<Node>><any>schema.items);
        } else {
            this.traverseIfNotNull(<Node>schema.items);
        }
        this.traverseCollection(schema.allOf);
        this.traverseCollection(schema.getProperties());
        if(NodeCompat.isNode(schema.additionalProperties)) {
            this.traverseIfNotNull(<Node>schema.additionalProperties);
        }
        this.traverseIfNotNull(schema.xml);
        this.traverseIfNotNull(schema.externalDocs);
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitHeader(io.apicurio.datamodels.openapi.models.OasHeader)
     * @param {OasHeader} node
     */
    public visitHeader(node : OasHeader) {
        node.accept(this.visitor);
        this.traverseHeader(node);
        this.traverseExtensions(node);
        this.traverseValidationProblems(node);
    }

    traverseHeader(node : OasHeader) {
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitResponseDefinition(io.apicurio.datamodels.core.models.common.IDefinition)
     * @param {*} node
     */
    public visitResponseDefinition(node : IDefinition) {
        this.visitResponse(<OasResponse><any>node);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.Traverser#traverseOperation(io.apicurio.datamodels.core.models.common.Operation)
     * @param {Operation} node
     */
    traverseOperation(node : Operation) {
        let operation : OasOperation = <OasOperation>node;
        this.traverseCollection(operation.parameters);
        this.traverseIfNotNull(operation.responses);
        this.traverseCollection(operation.security);
        super.traverseOperation(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitExample(io.apicurio.datamodels.core.models.common.IExample)
     * @param {*} node
     */
    public visitExample(node : IExample) {
        throw Object.defineProperty(new Error("Must be implemented by subclasses."), '__classes', { configurable: true, value: ['java.lang.Throwable','java.lang.Object','java.lang.RuntimeException','java.lang.Exception'] });
    }
}
OasTraverser["__class"] = "io.apicurio.datamodels.openapi.visitors.OasTraverser";
OasTraverser["__interfaces"] = ["io.apicurio.datamodels.core.visitors.IVisitor","io.apicurio.datamodels.core.visitors.ITraverser","io.apicurio.datamodels.openapi.visitors.IOasVisitor"];





import { IOasVisitor } from './IOasVisitor';

